export const COOKIE_CONSENT_KEY = 'sb-cookie-consent';
const ACCEPTED_VALUE = 'accepted';

export function isCookieConsentAccepted(): boolean {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === ACCEPTED_VALUE;
  } catch {
    return false;
  }
}

export function acceptCookieConsent(): void {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, ACCEPTED_VALUE);
  } catch {
    // Persistence is best-effort; banner may reappear on next visit.
  }
}
